/** @type {"B"} */
export const DESIGN_TYPE_BLOCK = "B";
/** @type {"P"} */
export const DESIGN_TYPE_PAGE = "P";
/** @type {"S"} */
export const DESIGN_TYPE_SITE = "S";
/** @type {"WB"} */
export const DESIGN_TYPE_WP_BLOCK = "WB";
/** @type {"WP"} */
export const DESIGN_TYPE_WP_PAGE = "WP";
/**
 * Not wired up in platform-api: it has no DESIGN_TYPE_* counterpart there, and
 * /sites/:id/exportV2 rejects it with a 400. Add it on the API side before
 * dispatching this from an export flow.
 * @type {"SB"}
 */
export const DESIGN_TYPE_SITE_BLOCK = "SB";
